import { render, staticRenderFns } from "./HammerJsInput.vue?vue&type=template&id=012e9252&"
import script from "./HammerJsInput.vue?vue&type=script&lang=ts&"
export * from "./HammerJsInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports